/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Link, NavLink } from "react-router-dom";
import LogoSidenav from "../../../assets/logo/logo_sidenav.png";
import LogoCollapsed from "../../../assets/logo/logoCollapsed.svg";
import routes, { authRoles } from "../../../navigation/route-config";
import { SET_SIDENAV } from "../../../store/actions";
import { permissions } from "../../shared/helpers";
import ProfileIcon from "../ProfileIcon/ProfileIcon";
import "./style.css";
import Submenu from "./SubMenu";

// Import all icons statically
import toolkitIcon from "../../../assets/icons/toolkit_light20@3x.png";
import customerIcon from "../../../assets/icons/customer_light20@3x.png";
import homeIcon from "../../../assets/icons/home_light20@3x.png";
import listIcon from "../../../assets/icons/list_light20@3x.png";
import lockIcon from "../../../assets/icons/lock_light20@3x.png";
import gearIcon from "../../../assets/icons/gear_light20@3x.png";

// Create icon mapping
const iconMap = {
  "toolkit_light20@3x.png": toolkitIcon,
  "customer_light20@3x.png": customerIcon,
  "home_light20@3x.png": homeIcon,
  "list_light20@3x.png": listIcon,
  "lock_light20@3x.png": lockIcon,
  "gear_light20@3x.png": gearIcon,
};

export default function SideNav() {
  const open = useSelector((state) => state.sidenav.open);
  const collapsed = useSelector((state) => state.sidenav.collapsed);
  const role = useSelector((state) => state.user.data.role);
  const userInfo = useSelector((state) => state.user.data);
  const accessibleRoutes = useSelector((state) => state.user.data.roles);

  let availablePaths = null;
  if (
    role === authRoles.buSubAdmin ||
    (role === authRoles.buInspector &&
      (userInfo?.is_lead_inspector || userInfo?.is_consultant))
  ) {
    availablePaths = permissions.filter((pr) =>
      accessibleRoutes.some((ar) => ar.alias === pr.value)
    );
  }

  const navRoutes = routes.filter((item) => {
    if (
      role === authRoles.buSubAdmin ||
      (role === authRoles.buInspector &&
        (userInfo?.is_lead_inspector || userInfo?.is_consultant))
    ) {
      const availablePaths = permissions.filter((pr) =>
        accessibleRoutes.some((ar) => ar.alias === pr.value)
      );

      return (
        item.showInSideNav &&
        availablePaths.some((i) => item.path.startsWith(i.routePath))
      );
    } else {
      return item.showInSideNav && item.roles.includes(role);
    }
  });
  const dispatch = useDispatch();
  const md = useMediaQuery({ query: "(max-width: 992px)" });
  const lg = useMediaQuery({ query: "(min-width: 993px)" });
  const getSidenavStyle = () => {
    if (!open) {
      return {
        marginLeft: "-230px",
        opacity: 0,
      };
    }
    return {
      width: collapsed ? "70px" : "230px",
      opacity: 1,
      isFocused: true,
    };
  };

  useEffect(() => {
    if (md) {
      dispatch({ type: SET_SIDENAV, payload: { open: false } });
    } else if (lg) {
      dispatch({ type: SET_SIDENAV, payload: { open: true } });
    }
  }, [md, lg]);

  return (
    <Navbar
      id="side-nav"
      className={collapsed ? "sidenav-collapsed" : ""}
      style={getSidenavStyle()}
      tabIndex="-1"
      onBlur={() => {}}
    >
      {!collapsed && (
        <Link to="/" className="navbar-logo">
          <img
            src={LogoSidenav}
            width="190px"
            className="d-inline-block align-top"
            alt="Scout logo"
          />
        </Link>
      )}
      {collapsed && (
        <Link to="/" className="navbar-logo-collapsed">
          <img
            src={LogoCollapsed}
            className="d-inline-block align-top"
            alt="Scout logo"
          />
        </Link>
      )}
      {role === authRoles.buAdmin &&
      !(
        userInfo?.first_name &&
        userInfo?.last_name &&
        userInfo?.isSubscribed
      ) ? (
        <ProfileIcon
          subscribed={false}
          style={{ height: "100%", justifyContent: "flex-end" }}
        />
      ) : (
        <>
          <div className="mt-2"></div>

          <div className="sidenav-scroll-container">
            <Nav className="column">
              {navRoutes.map((item, i) => (
                <React.Fragment key={item.path}>
                  {item.hasChildren ? (
                    <Submenu data={item} />
                  ) : (
                    <NavLink
                      id={item.name}
                      key={item.path + item.name}
                      to={item.path}
                      exact={item.name === "Super Admin"}
                      style={{ color: "#84857a" }}
                      className="nav-link"
                      activeClassName="active"
                      activeStyle={{ color: "#2F481E" }}
                      title={collapsed ? item.name : ""}
                    >
                      {item.icon && iconMap[item.icon] ? (
                        <img src={iconMap[item.icon]} alt="icon" />
                      ) : null}
                      {!collapsed && <span>{item.name}</span>}
                    </NavLink>
                  )}
                  {navRoutes[i + 1]?.name === "Settings" ? (
                    <hr
                      style={{ width: "80%", margin: "1rem auto 1rem auto" }}
                    />
                  ) : null}
                </React.Fragment>
              ))}
            </Nav>
            {!collapsed && <ProfileIcon />}
          </div>
        </>
      )}
    </Navbar>
  );
}
